var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToastSuccessCheckIcon = function SvgToastSuccessCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m5.78-14.47a.75.75 0 0 0 0-1.06l-.75-.75a.75.75 0 0 0-1.06 0l-5.47 5.47-2.47-2.47a.75.75 0 0 0-1.06 0l-.75.75a.75.75 0 0 0 0 1.06l3.75 3.75a.75.75 0 0 0 1.06 0z",
    clipRule: "evenodd"
  })));
};
export default SvgToastSuccessCheckIcon;